import { getStringListDropdownOptions } from '@ben/columbia/api';
import Select, { type ISelect } from '@ben/orion/deprecated-select';
import { useQuery } from '@tanstack/react-query';
import { startCase, toLower } from 'lodash';
import type { ForwardedRef } from 'react';
import { forwardRef, memo, useMemo } from 'react';

interface IModelMultiDropdown extends Omit<ISelect, 'onChange' | 'options'> {
  apiName: string;
  defaultValue: string[];
  onChange: (values: string[]) => void;
  hasError?: boolean;
  width?: string;
}

const ModelMultiDropdown = forwardRef(
  (
    {
      name,
      onChange,
      defaultValue,
      apiName,
      hasError,
      width,
      ...rest
    }: IModelMultiDropdown,
    ref: ForwardedRef<unknown>
  ) => {
    const { isLoading, data } = useQuery(
      [`dropdownOptionsFor-${apiName}`],
      getStringListDropdownOptions(apiName)
    );
    const options = useMemo(() => {
      return isLoading || !data
        ? []
        : data.map((item) => ({ key: item, label: startCase(toLower(item)) }));
    }, [data, isLoading]);

    if (isLoading) return false;

    return (
      <Select
        ref={ref}
        {...rest}
        name={name}
        showSearch={true}
        defaultValue={defaultValue}
        options={options}
        onChange={(values) => {
          onChange(values as string[]);
        }}
        hasError={hasError}
        width={width}
        disabled={isLoading}
      />
    );
  }
);
ModelMultiDropdown.displayName = 'ModelMultiDropdown';
export default memo(ModelMultiDropdown);
